module.exports = __webpack_public_path__ + "img/bert-benefit-2.5829cf6b.jpg";